export const FETCH_FLOOR_PLAN_LIST_IDENTIFIER = "fetch-floor-plan-list";
